export const resolveFileUrl = (path) => {
  return path || "";
};
